import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { AlertType, DzToastAlert } from '@blk/daisy/combinations/notifications';
import { v4 as uuid } from 'uuid';

import { DcrPrefixMapping, NotificationType } from '../constants';

@Injectable({
	providedIn: 'root'
}) export class PartnerNotificationService {
	constructor(private contentService: ContentService) { }

	public showNotification(notificationType: NotificationType, selectedPartnerId: string = ''): DzToastAlert[] {
		const dcrKey = DcrPrefixMapping[notificationType].dcrKey;
		return this.buildNotification(
			notificationType,
			this.contentService.get(
				notificationType === NotificationType.API_ERROR ||
					notificationType === NotificationType.UNAUTHORIZED_ERROR ||
					notificationType === NotificationType.DUPLICATE_NAME
					? dcrKey : dcrKey + selectedPartnerId,
				DcrPrefixMapping[notificationType].dcrValue
			),
			notificationType === NotificationType.UNAUTHORIZED_ERROR ? null : 5000
		);
	}

	public buildNotification(notificationType: NotificationType, message: string, duration?: number): DzToastAlert[] {
		let alert = {
			id: uuid(),
			message,
			type: notificationType === NotificationType.LOGIN_SUCCESS ? AlertType.success : AlertType.error
		} as DzToastAlert;
		if (duration) {
			alert = { ...alert, duration };
		}
		return [alert];
	}
}
